import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';


export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    item: null,
    ownTrainer: null,
    pvpMatches: [],
    pvpRankedList: [],
    infoMessages: [],
    userLoading: false,
    user: {},
  },
  actions,
  getters,
  mutations,
};


